import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withMultiplierConfiguration from "./configuration/withMultiplierConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as soundActions } from "../../core/reducers/soundReducer";

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    layoutMode: any;
    multiplierActive: any;
    multiplierCurrentValue: any;
    storeMultiplierCurrentValue: any;
    blastStart: any;
    showBetHistory: any;
    showGameSettings: any;
    showSettingGameRules: any;
    showSettingPanelForMobile: any;
    showBuyFeature: any;
    showAutoplay: any;
    allSoundSFXStop: any;
    soundIsPlaying: any;
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class Multiplier extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected multiplierContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected objName: any;
    protected multiplierTextMobile: any;
    protected multiplierText_1_desktop: any;
    protected multiplierText_2_desktop: any;


    protected blastAnimationDesktop: any;
    protected blastAnimationMobile: any;
    protected timerTime: number = 2500;
    protected timerDelay: number = 20;
    protected multiplierHighestValue: number = 10;
    protected createValue: number = 302;
    protected endeValue: number = 502;
    protected counter: number = 0;
    protected timer: number = 1850;
    protected thing: any;




    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.multiplierContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
            this.createValue = 291;
            this.endeValue = 391;
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));
        this.objName = 1;
    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //this method will call after the first rendering for scaling and logo animation looping
    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }

    //this method will initialize object to variables
    initializeObjectInVariable() {
        //  this.multiplierTextMobile = UIManager.getRef("multiplierText_mobile");
        this.multiplierText_1_desktop = UIManager.getRef("multiplierText_1_desktop");
        this.multiplierText_2_desktop = UIManager.getRef("multiplierText_2_desktop");




        this.blastAnimationMobile = UIManager.getRef("blastAnimation_mobile");
        this.blastAnimationDesktop = UIManager.getRef("multiplierBlast");
    }

    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
        this.masking();
    }



    masking() {

        this.thing = new PIXI.Graphics();
        this.thing.beginFill(0xDE3249);
        // thing.drawRect(110, 353, 160, 90);
        isMobile && window.innerWidth < window.innerHeight ? this.thing.drawRect(62, 1183, 160, 90) : this.thing.drawRect(110, 353, 160, 90);
        // thing.drawRect(62, 1183, 160, 90);
        this.thing.endFill();
        this.thing.name = "maskGraphic";

        if (UIManager.getRef("multiplierContainer").children.length > 1) {
            UIManager.getRef("multiplierContainer").children.pop();
        }

        UIManager.getRef("multiplierContainer")
            && UIManager.getRef("multiplierContainer").addChild(this.thing);
        UIManager.getRef("multiplierContainer")
            && (UIManager.getRef("multiplierContainer").mask = this.thing);
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    numberStartChanging(nextProps: any, previousValue: any, nextValue: any) {

        // if (isMobile) {
        //     this.multiplierTextMobile.text = "x" + nextProps.multiplierCurrentValue;

        // }
        // else {}
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "multiplierFG", loop: false }]);
        }
        let updatedText: any, prevText: any;
        if (this.multiplierText_1_desktop.y == this.endeValue) {
            this.multiplierText_1_desktop.y = this.createValue;
            updatedText = this.multiplierText_1_desktop;
            prevText = this.multiplierText_2_desktop;

        }
        else if (previousValue !== 0) {
            this.multiplierText_2_desktop.y = this.createValue;
            updatedText = this.multiplierText_2_desktop;
            prevText = this.multiplierText_1_desktop;

        }
        else {
            updatedText = this.multiplierText_1_desktop;
            prevText = this.multiplierText_2_desktop;
        }

        updatedText.text = "X" + nextProps.multiplierCurrentValue;
        new Tween(
            [updatedText],
            {

                'y': { start: updatedText.y, end: updatedText.y + 100 }

            },
            0.5,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, () => {


            }
        )

        new Tween(
            [prevText],
            {

                'y': { start: prevText.y, end: prevText.y + 100 }

            },
            0.5,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, () => {

            }
        )

    }

    handleMultiplierVisibility(nextProps: any) {
        let multiContainer = UIManager.getRef("multiplierContainer");

        if (multiContainer) {
            if (nextProps.showBetHistory
                || nextProps.showGameSettings
                || nextProps.showSettingGameRules
                || nextProps.showSettingPanelForMobile
            ) {
                multiContainer.visible = false;
            } else {
                multiContainer.visible = true;
            }
            if (nextProps.showAutoplay && isMobile) {
                multiContainer.visible = false;
            }
        }
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode || nextProps.multiplierActive !== this.props.multiplierActive
            || nextProps.multiplierCurrentValue !== this.props.multiplierCurrentValue
            || nextProps.showBetHistory !== this.props.showBetHistory
            || nextProps.showGameSettings !== this.props.showGameSettings
            || nextProps.showSettingGameRules !== this.props.showSettingGameRules
            || nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile
            || nextProps.blastStart !== this.props.blastStart
            || nextProps.showAutoplay !== this.props.showAutoplay
            || nextProps.soundIsPlaying !== this.props.soundIsPlaying
            || nextProps.allSoundSFXStop !== this.props.allSoundSFXStop
            || nextProps.showBuyFeature !== this.props.showBuyFeature) {

            if (nextProps.showBuyFeature != this.props.showBuyFeature) {
                let container = UIManager.getRef("multiplier_overlay");
                if (container) {
                    nextProps.showBuyFeature ? container.visible = true : container.visible = false;
                }
            }
            if (nextProps.showBetHistory !== this.props.showBetHistory
                || nextProps.showGameSettings !== this.props.showGameSettings
                || nextProps.showSettingGameRules !== this.props.showSettingGameRules
                || nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile
                || nextProps.showAutoplay !== this.props.showAutoplay
            ) {

                this.handleMultiplierVisibility(nextProps);
            }
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
                this.masking();





            }
            if (nextProps.multiplierActive) {



            }
            if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {
                this.props.setMultiplierValue(this.props.storeMultiplierCurrentValue);
            }
            if (nextProps.multiplierCurrentValue !== this.props.multiplierCurrentValue) {



                if (this.counter > 0 && !nextProps.updateMultiplierForBuyFeature && nextProps.showBannerForReconstruction) {
                    let timer = TIMER.TimerManager.createTimer(this.timer);
                    timer.on('end', () => {
                        this.numberStartChanging(nextProps, this.props.multiplierCurrentValue, nextProps.multiplierCurrentValue);
                    });
                    timer.start();

                }
                else {

                    this.numberStartChanging(nextProps, this.props.multiplierCurrentValue, nextProps.multiplierCurrentValue);
                }
                this.counter++;
            }
            return false;

        }

        return false;
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {


    }

    render() {
        return (
            <UIManager id={"multiplierContainer"} name={"multiplierContainer"} type={"Container"}
                ref={i => this.multiplierContainer = i} configGame={this.props.configGame}
                app={this.app}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            scope={this} />
                    )
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'baseGameReconstructionState' | 'MultiplierState' | 'soundState' | 'autoplayState' | 'mainSettingPanelState' | 'behaviourState' | 'applicationState' | 'gridsState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        multiplierActive: state.MultiplierState.multiplierActive,
        multiplierCurrentValue: state.MultiplierState.multiplierCurrentValue,
        storeMultiplierCurrentValue: state.MultiplierState.storeMultiplierCurrentValue,
        blastStart: state.gridsState.blastStart,
        showBetHistory: state.behaviourState.showBetHistory,
        showGameSettings: state.behaviourState.showGameSettings,
        showSettingGameRules: state.behaviourState.showSettingGameRules,
        showSettingPanelForMobile: state.mainSettingPanelState.showSettingPanelForMobile,
        showBuyFeature: state.behaviourState.showBuyFeature,
        showAutoplay: state.autoplayState.showAutoplay,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        soundIsPlaying: state.soundState.soundIsPlaying,
        updateMultiplierForBuyFeature: state.behaviourState.updateMultiplierForBuyFeature,
        showBannerForReconstruction: state.baseGameReconstructionState.showBannerForReconstruction,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
    }))(withMultiplierConfiguration(Multiplier)));